<div class="content">
  <div class="card">
    <div class="card-header header-elements-inline" [ngBusy]="busy">
      <h6 class="card-title">Liste des secteurs d'activité</h6>
      <div class="heading-elements">
        <button
          [routerLink]="['/secteurs-activite/add']"
          type="button"
          class="btn btn-info btn-xs"
        >
          <i class="icon-plus2 position-left"></i>Ajouter un secteur
        </button>
      </div>
    </div>

    <br />

    <div class="card-body">
      <table
        class="table perso-table"
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Nom</th>
            <th>Description</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  </div>
</div>